import React, { useCallback, useMemo, useState } from 'react'
import { Box, useTheme } from '@mui/material'
import GenericButton from '../../../components/GenericButton'
import { ButtonSize, ButtonType } from '../../../components/GenericButton/styles'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import GenericAutocomplete from '../../../components/FormElements/FormAutoComplete'
import { FormProvider, useForm } from 'react-hook-form'
import { useQuery } from '@tanstack/react-query'
import { PermissionManagementManager } from '../../../APIManager'
interface PermissionManagementHeaderProps {
  onApply?: (entity: any | null) => void
  disabledProjectAndTermHeader?: boolean
}

export const PermissionManagementHeader: React.FC<PermissionManagementHeaderProps> = ({ onApply, disabledProjectAndTermHeader }) => {
  const [selectedEntity, setSelectedEntity] = useState<string | null>(null)
  const theme = useTheme()
  const methods = useForm({ defaultValues: { permissionEntity: null } })

  const { data: entities = [], isLoading } = useQuery<string[]>({
    queryKey: ['permissionEntities'],
    queryFn: async () => {
      const { data } = await PermissionManagementManager.getPermission()
      return data
    }
  })

  const autocompleteSx = useMemo(() => ({
    [theme.breakpoints.up('md')]: { maxWidth: '256px' }
  }), [theme])

  const handleApply = useCallback(() => {
    if (onApply) onApply(selectedEntity)
  }, [onApply, selectedEntity])

  return (
    <>
      <FormProvider {...methods}>
        <Box display="flex" alignItems="center" gap={2}>
          <Box sx={{ ...autocompleteSx }} flex={1}>
            <GenericAutocomplete<string>
              name="permissionEntity"
              label="Select Permission"
              placeholder='Permissions'
              options={entities}
              loading={isLoading}
              readOnly={!!disabledProjectAndTermHeader}
              getOptionLabel={(option) => option}
              getOptionValue={(option) => option}
              onChange={(val) => { setSelectedEntity(val) }}
            />
          </Box>
          <Box paddingTop={'30px'} >
            <GenericButton
              buttonType={ButtonType.Primary}
              buttonSize={ButtonSize.Medium}
              icon={<ArrowForwardIcon />}
              onClick={handleApply}
              disabled={!selectedEntity || isLoading}
            />
          </Box>
        </Box>
      </FormProvider>
    </>

  )
}
